// Copyright The Perses Authors
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import { PersesColor } from './types';

export const blue: PersesColor = {
  50: '#E7F1FC',
  100: '#D0E3FA',
  150: '#B8D5F7',
  200: '#A1C7F5',
  300: '#72ABF0',
  400: '#438FEB',
  500: '#1473E6',
  600: '#105CB8',
  700: '#0C458A',
  800: '#082E5C',
  850: '#062345',
  900: '#04172E',
  950: '#020C17',
};
